"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDefaultValidationMessages = void 0;
const react_1 = require("react");
const react_intl_1 = require("react-intl");
function useDefaultValidationMessages() {
    const messages = react_intl_1.defineMessages({
        EAS_VALIDATION_MSG_REQUIRED: {
            id: 'EAS_VALIDATION_MSG_REQUIRED',
            defaultMessage: 'Musí být vyplněné',
        },
        EAS_VALIDATION_MSG_IS_THE_SAME: {
            id: 'EAS_VALIDATION_MSG_IS_THE_SAME',
            defaultMessage: 'Neshoduje se',
        },
        EAS_VALIDATION_MSG_MEETS_RULES: {
            id: 'EAS_VALIDATION_MSG_MEETS_RULES',
            defaultMessage: 'Nesplňuje pravidla',
        },
        EAS_VALIDATION_MSG_MEETS_FORMAT: {
            id: 'EAS_VALIDATION_MSG_MEETS_FORMAT',
            defaultMessage: 'Chybný formát',
        },
        EAS_VALIDATION_MSG_DOES_NOT_EXIST: {
            id: 'EAS_VALIDATION_MSG_DOES_NOT_EXIST',
            defaultMessage: 'Už existuje',
        },
        EAS_VALIDATION_MSG_MAX_LENGTH: {
            id: 'EAS_VALIDATION_MSG_MAX_LENGTH',
            defaultMessage: 'Musí byt kratší než {max} znaků',
        },
    });
    const requiredField = messages.EAS_VALIDATION_MSG_REQUIRED.id +
        ';;' +
        messages.EAS_VALIDATION_MSG_REQUIRED.defaultMessage; // Musí být vyplněné
    const isTheSame = messages.EAS_VALIDATION_MSG_IS_THE_SAME.id +
        ';;' +
        messages.EAS_VALIDATION_MSG_IS_THE_SAME.defaultMessage; // Neshoduje se
    const meetsRules = messages.EAS_VALIDATION_MSG_MEETS_RULES.id +
        ';;' +
        messages.EAS_VALIDATION_MSG_MEETS_RULES.defaultMessage; // Nesplňuje pravidla
    const meetsFormat = messages.EAS_VALIDATION_MSG_MEETS_FORMAT.id +
        ';;' +
        messages.EAS_VALIDATION_MSG_MEETS_FORMAT.defaultMessage; // Zlý formát
    const doesNotExist = messages.EAS_VALIDATION_MSG_DOES_NOT_EXIST.id +
        ';;' +
        messages.EAS_VALIDATION_MSG_DOES_NOT_EXIST.defaultMessage; // Už existuje
    const maxLength = react_1.useCallback(({ max }) => ({
        key: messages.EAS_VALIDATION_MSG_MAX_LENGTH.id +
            ';;' +
            messages.EAS_VALIDATION_MSG_MAX_LENGTH.defaultMessage,
        values: { max },
    }), [
        messages.EAS_VALIDATION_MSG_MAX_LENGTH.defaultMessage,
        messages.EAS_VALIDATION_MSG_MAX_LENGTH.id,
    ]); // Musí byt kratší než {length} znaků
    return react_1.useMemo(() => ({
        requiredField,
        maxLength,
        isTheSame,
        meetsRules,
        meetsFormat,
        doesNotExist,
    }), [doesNotExist, isTheSame, maxLength, meetsFormat, meetsRules, requiredField]);
}
exports.useDefaultValidationMessages = useDefaultValidationMessages;
//# sourceMappingURL=validation-messages.js.map